<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col class="Full-Course-Library-Title">Trials</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="tt-muted">
          Live, expired and extended free trials, with how each one is engaging.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="rows"
            :loading="loading"
            :server-items-length="total"
            :options.sync="options"
            :footer-props="{ 'items-per-page-options': [25, 50, 100] }"
            class="elevation-1"
          >
            <template v-slot:item.state_label="{ item }">
              <v-chip small :color="stateColor(item.state)" dark>{{ item.state_label }}</v-chip>
            </template>
            <template v-slot:item.days_remaining="{ item }">
              {{ formatDays(item) }}
            </template>
            <template v-slot:item.started_at="{ item }">{{ formatDate(item.started_at) }}</template>
            <template v-slot:item.last_login_at="{ item }">{{ item.last_login_at ? formatDate(item.last_login_at) : 'Never' }}</template>
            <template v-slot:item.unsubscribed="{ item }">
              <v-icon v-if="item.unsubscribed" small color="#b3261e">mdi-email-off</v-icon>
              <span v-else class="tt-muted">&mdash;</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import companyAPI from '@/api/company.js';

export default {
  name: 'SuperAdminTrials',
  components: { LayoutBasic },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      options: {},
      headers: [
        { text: 'Company', value: 'company_name' },
        { text: 'Owner', value: 'owner_email' },
        { text: 'Status', value: 'state_label', sortable: false },
        { text: 'Started', value: 'started_at', sortable: false },
        { text: 'Days left', value: 'days_remaining', sortable: false },
        { text: 'Logins', value: 'logins', sortable: false },
        { text: 'Last login', value: 'last_login_at', sortable: false },
        { text: 'Emails', value: 'emails_sent', sortable: false },
        { text: 'Unsub', value: 'unsubscribed', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    load() {
      this.loading = true;
      const page = this.options.page || 1;
      const limit = this.options.itemsPerPage || 25;
      companyAPI
        .getTrials('?page=' + page + '&limit=' + limit)
        .then((resp) => {
          const body = resp.data || {};
          this.rows = body.data || [];
          this.total = (body.pagination && body.pagination.total) || 0;
        })
        .catch(() => {
          this.$snotify && this.$snotify.error('Could not load trials.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(v) {
      if (!v) return '';
      const d = new Date(String(v).replace(' ', 'T'));
      if (isNaN(d.getTime())) return v;
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    formatDays(item) {
      if (item.state === 2) return 'Expired';
      if (item.days_remaining === null || item.days_remaining === undefined) return '';
      if (item.days_remaining <= 0) return 'Ends today';
      return item.days_remaining + (item.days_remaining === 1 ? ' day' : ' days');
    },
    stateColor(state) {
      if (state === 1) return '#2fa84f';
      if (state === 5) return '#08a0a8';
      if (state === 2) return '#b3261e';
      return '#8a94a6';
    },
  },
};
</script>

<style scoped>
.tt-muted { color: #8a94a6; }
</style>
